import { AuthContent, AuthContext } from '@admin/components/auth'
import PasswordField from '@admin/components/form/password'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Password extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    account: PropTypes.object,
    token: PropTypes.string,
    onNext: PropTypes.func
  }

  state = {
    confirmation: '',
    message: null,
    password: '',
    status: 'pending'
  }

  _handleNext = this._handleNext.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleToggle = this._handleToggle.bind(this)

  render() {
    return (
      <AuthContext.Consumer>
        {(authContext) => {
          this._authContext = authContext
          return this._renderContent()
        }}
      </AuthContext.Consumer>
    )
  }

  _renderContent() {
    const { message } = this.state
    return (
      <AuthContent>
        <div className="maha-auth-form">
          <div className="maha-auth-content">
            <h2><T text="t(Choose a Password)" /></h2>
            <p><T text="t(Please enter and confirm your new password)" /></p>
          </div>
          { message &&
            <div className="maha-auth-error">
              <T text={ message } />
            </div>
          }
          <div className="ui form">
            <div className="field password-field">
              <PasswordField { ...this._getPassword() } />
            </div>
            <div className="field password-field">
              <PasswordField { ...this._getConfirm() } />
            </div>
            <div className="field button-field">
              <Button { ...this._getContinue() } />
            </div>
          </div>
        </div>
      </AuthContent>
    )
  }

  _getContinue() {
    const { status } = this.state
    return {
      label: 'Continue',
      loading: status === 'submitting',
      color: 'blue',
      size: 'large',
      handler: this._handleSubmit
    }
  }

  _getConfirm() {
    return {
      onChange: this._handleUpdate.bind(this, 'confirmation'),
      onEnter: this._handleSubmit
    }
  }

  _getPassword() {
    return {
      onChange: this._handleUpdate.bind(this, 'password'),
      onEnter: this._handleSubmit
    }
  }

  _getToggle() {
    const { show } = this.state
    return {
      icon: show ? 'eye-slash' : 'eye',
      className: '',
      handler: this._handleToggle
    }
  }

  _handleNext({ data }) {
    const { account } = this.props
    const { token } = data
    account.token = token
    this.props.onNext('complete', account)
  }

  _handleSubmit() {
    const { password, confirmation } = this.state
    const { token } = this.props
    this.setState({ status: 'submitting' })
    this.context.network.request({
      endpoint: '/api/admin/reset/password',
      method: 'POST',
      body: { token, password, confirmation },
      onSuccess: this._handleNext,
      onFailure: ({ message }) => {
        this._authContext.shake()
        this.setState({
          message,
          status: 'pending'
        })
      }
    })
  }

  _handleToggle() {
    const { show } = this.state
    this.setState({
      show: !show
    })
  }

  _handleUpdate(key, value) {
    this.setState({
      [key]: value
    })
  }

}

export default Password
